import { render } from "./VisualizarContato.vue?vue&type=template&id=11860bdc&scoped=true"
import script from "./VisualizarContato.vue?vue&type=script&lang=js"
export * from "./VisualizarContato.vue?vue&type=script&lang=js"

import "./VisualizarContato.vue?vue&type=style&index=0&id=11860bdc&scoped=true&lang=css"

import exportComponent from "I:\\Centrion\\projetos\\aut_fri_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11860bdc"]])

export default __exports__